import { iconInfrastructure } from '../constants/icon_infrastructure';
import {
  ICommunicationSetSchema,
  CanalizationCommunicationNames,
  GasCommunicationNames,
  HeatingCommunicationNames,
  RoadCommunicationNames,
  WaterSupplyCommunicationNames,
  TVillageInfrastructure,
  VillageInfrastructureNames,
} from '../types';

function getCommunicationSet(communicationSet?: ICommunicationSetSchema) {
  if (!communicationSet) {
    return [];
  }

  const { canalization, electricity, gas, heating, road, waterSupply } = communicationSet;

  return [
    canalization
      ? [
          {
            text: `Канализация: ${CanalizationCommunicationNames[canalization]}`,
            icon: iconInfrastructure['canalization'],
          },
        ]
      : [],
    electricity ? [{ text: `Электричество`, icon: iconInfrastructure['electricity'] }] : [],
    gas?.length
      ? gas.map(item => ({ text: `Газ: ${GasCommunicationNames[item]}`, icon: iconInfrastructure['gas'] }))
      : [],
    heating?.length
      ? heating.map(item => ({
          text: `Отопление: ${HeatingCommunicationNames[item]}`,
          icon: iconInfrastructure['heating'],
        }))
      : [],
    road?.length
      ? road.map(item => ({ text: `Дороги: ${RoadCommunicationNames[item]}`, icon: iconInfrastructure['road'] }))
      : [],
    waterSupply?.length
      ? waterSupply.map(item => ({
          text: `Водоснабжение: ${WaterSupplyCommunicationNames[item]}`,
          icon: iconInfrastructure['waterSupply'],
        }))
      : [],
  ].reduce((a, b) => a.concat(b));
}

export interface IGetInfrastructureElementsResult {
  text: string;
  icon(): JSX.Element;
}
export function getInfrastructureElements(
  infrastructureList?: TVillageInfrastructure[],
  communicationSet?: ICommunicationSetSchema,
) {
  return [
    Array.isArray(infrastructureList)
      ? infrastructureList.map(item => ({
          text: VillageInfrastructureNames[item],
          icon: iconInfrastructure[item],
        }))
      : [],
    getCommunicationSet(communicationSet),
  ].reduce((a, b) => a.concat(b));
}

export function getInfrastructureElementsStrings(
  infrastructureList?: TVillageInfrastructure[],
  communicationSet?: ICommunicationSetSchema,
) {
  return getInfrastructureElements(infrastructureList, communicationSet).map(({ text }) => text);
}
